import { render, staticRenderFns } from "./AdminEditTemplate.vue?vue&type=template&id=658c315a&scoped=true&"
import script from "./AdminEditTemplate.vue?vue&type=script&lang=js&"
export * from "./AdminEditTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditTemplate.vue?vue&type=style&index=0&id=658c315a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658c315a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('658c315a')) {
      api.createRecord('658c315a', component.options)
    } else {
      api.reload('658c315a', component.options)
    }
    module.hot.accept("./AdminEditTemplate.vue?vue&type=template&id=658c315a&scoped=true&", function () {
      api.rerender('658c315a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminEditTemplate.vue"
export default component.exports